import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Select,
  useToast,
  IconButton,
  Divider,
  Button,
  ModalFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Stat,
  StatLabel
} from "@chakra-ui/react";

import TextEditor from "../common/TextEditor";

import { GiClick } from "react-icons/gi";

import CaseService from "../../services/cases.service";
import ConfirmDialog from "./confirmDialog";



const CaseAction = (props) => {
  const toast = useToast();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [action, setAction] = useState("");
  const [validationErrors, setValidationErrors] = useState({ action: "", statusForGroupEdit: "",commentForGroupEdit:"" });
  const [uncloseCaseCountForDelete, setUncloseCaseCountForDelete] = useState(0);
  const [email , setEmail] = useState('user');
  const [isEditCaseOpen, setIsEditCaseOpen] = useState(false);
  const [statusForGroupEdit,setStatusForGroupEdit] = useState('');
  const [commentForGroupEdit,setCommentForGroupEdit] = useState('');
  const onDialogClose = () => setIsDialogOpen(false);
  const statuses = JSON.parse(localStorage.getItem("properties")).caseStatus;
  
  useEffect(() => {
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
    if (user.user && user.user.email)
      setEmail(user.user.email)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const deleteCase = async () => {
    const selectedRows = props.gridApi.getSelectedRows();
    props.setisLoading(true);
    let data = await CaseService.bulkRemove({
      caseIds: selectedRows.reduce((c, i) => {
        return [...c, i._id];
      }, []),
    });
    if (data.error) {
      toast({
        title: data.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      props.setisLoading(false);
      return;
    } 
    if (data.warning) {
      toast({
        title: data.warning,
        position: "top",
        status: "warning",
        isClosable: true,
      });
      props.setisLoading(false);
      return;
    } 
    toast({
      title: `Deleted..!`,
      position: "top",
      status: "success",
      isClosable: true,
    });
    props.gridApi.applyTransaction({ remove: selectedRows });
    setUncloseCaseCountForDelete(0);
    setAction('');
    props.setisLoading(false);
  };

  const handleAction = () => {
    const selectedRows = props.gridApi.getSelectedRows();
    if (action === "") {
      setValidationErrors({ ...validationErrors, action: "Action required." });
      return;
    }
    if (selectedRows.length === 0) {
      toast({
        title: "Please select the case.",
        position: "top",
        status: "info",
        isClosable: true,
      });
      return;
    }
    if (action === "DELETE") {
      setUncloseCaseCountForDelete(
        selectedRows.filter((item) =>  !["CLOSE",'DISMISSED'].includes(item.status)).length
      );
      setValidationErrors({ ...validationErrors, action: "" });
      setIsDialogOpen(true);
    }
    if (action === "EDIT") {
      setIsEditCaseOpen(true)
    }
    return;
  };

  const setCommentFromEditor = (value) => {
    setCommentForGroupEdit(value);
    return;
  };
  const onCloseBulkEdit = ()=>{
    setCommentForGroupEdit('');
    setStatusForGroupEdit('');
    setIsEditCaseOpen(false);
    setValidationErrors(prev => { return{...prev, statusForGroupEdit: "",commentForGroupEdit:"" }});
    return;
  }
  const editCases = async() =>{
    const selectedRows = props.gridApi.getSelectedRows();
    if (statusForGroupEdit === "" || commentForGroupEdit ==='') {
      if (statusForGroupEdit === "")
        setValidationErrors(prev => { return{...prev, statusForGroupEdit: "Status required." }});
      if (commentForGroupEdit === "")
        setValidationErrors(prev => { return{...prev, commentForGroupEdit: "Comment required." }});  
      return;
    }
    let  caseIds = selectedRows.reduce((c, i) => {
      return [...c, i._id];
    }, []);
    props.setisLoading(true);
    let data = await CaseService.bulkEdit({caseIds,'comment':{'comment':commentForGroupEdit,'date':new Date(),'author':email},'status':statusForGroupEdit});
    if (data.error) {
      toast({
        title: data.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      props.setisLoading(false);
      return;
    } 
    if (data.warning) {
      toast({
        title: data.warning,
        position: "top",
        status: "warning",
        isClosable: true,
      });
      props.setisLoading(false);
      return;
    } 
    toast({
      title: `Updated..!`,
      position: "top",
      status: "success",
      isClosable: true,
    });
    setCommentForGroupEdit('');
    setStatusForGroupEdit('');
    if(props.hasOwnProperty('view')){
      if(props.view === 'week'){
        let updatedItems = [];
        selectedRows.forEach(function (oldItem) {
          let newItem = { ...oldItem, status: data[0].status };
          updatedItems.push(newItem);
        });
        props.gridApi.applyTransaction({ update: updatedItems });
      }else{
        props.gridApi.applyTransaction({ update: data });  
      }
    }else{
      props.gridApi.applyTransaction({ update: data });
    }
    setIsEditCaseOpen(false);
    props.gridApi.deselectAll();
    setAction('');
    props.setisLoading(false);
    return;
  }

  return (
    <>
    {props.actionList.length>1 &&
        <><Box p={2} pr={4}>
        <Flex>
            <Select
            pr={1}
            fontSize=".8rem"
            width='150px'
            borderColor={validationErrors.action ? "red" : "#E2E8F0"}
            style={{ borderRadius: "5px" }}
            size="md"
            onChange={(e) => {
                setValidationErrors({
                ...validationErrors,
                action: "",
                });
                return setAction(e.target.value);
            }}
            value={action}
            >
            {props.actionList.map((s, i) => {
                return (
                <option key={i} value={s.value} size="sm">
                    {s.label}
                </option>
                );
            })}
            </Select>
            <IconButton
            size="md"
            aria-label="Search"
            borderWidth={'1px'}
            borderColor={'rgb(94,94,114,.3)'}
            onClick={handleAction}
            icon={<GiClick />}
            />
            {isDialogOpen && (
            <ConfirmDialog
                isOpen={isDialogOpen}
                onClose={onDialogClose}
                header={"Case Deletion"}
                body={`${
                uncloseCaseCountForDelete
                    ? `There are ${uncloseCaseCountForDelete} uncolsed case. `
                    : ""
                }
            Are you sure? You can't undo this action afterwards`}
                onDelete={deleteCase}
            />
            )}
            <Modal isOpen={isEditCaseOpen} onClose={onCloseBulkEdit} size={'4xl'} closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit all cases </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                <Box pl={2}>
                    <Stat>
                    <StatLabel>Status</StatLabel>
                    </Stat>
                    <Select
                    size="xs"
                    onChange={(e) => {setStatusForGroupEdit(e.target.value);setValidationErrors(prev => { return{...prev, statusForGroupEdit: "" }});}}
                    value={statusForGroupEdit}
                    borderColor={validationErrors.statusForGroupEdit ? "red" : "#E2E8F0"}
                    >
                    {statuses.map((s, i) => {
                        return (
                        <option key={i} value={s.value}>
                            {s.label}
                        </option>
                        );
                    })}
                    </Select>
                    <Box 
                    borderWidth="1px" 
                    borderRadius="lg" 
                    h={500} 
                    mt={3} 
                    p={1} 
                    borderColor={validationErrors.commentForGroupEdit ? "red" : "#E2E8F0"}
                    onClick={()=> setValidationErrors(prev => { return{...prev, commentForGroupEdit: "" }})}
                    >
                    <TextEditor handleChange={setCommentFromEditor} />
                    </Box>
                </Box>
                </ModalBody>
                <ModalFooter>
                <Button colorScheme="red" mr={3} onClick={onCloseBulkEdit}>
                    Cancel
                </Button>
                <Button colorScheme="blue" mr={3} onClick={editCases}>
                    Save
                </Button>
                </ModalFooter>
            </ModalContent>
            </Modal>
        </Flex>
        </Box>
        <Divider pr={2} h="60px" orientation="vertical" />
        </>
    }
    </>
  );
};

export default CaseAction;
